import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    leftColumn: {
        minWidth: theme.spacing(12),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        borderRight: `1px solid ${theme.colors.gray[200]}`,
    },
    rightColumn: {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
    },
    rightColumnInputs: {
        display: 'flex',
        gap: theme.spacing(1),
        '& > *': {
            flex: 1,
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2.5),
            '& > *': {
                width: '100%',
                '& > *': {
                    width: '100%',
                },
            },
        },
        '& .MuiInputBase-root:not(.Mui-focused)': {
            '& .MuiInputAdornment-root': {
                display: 'none',
            },
        },
    },
    rightColumnButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(3),
        gap: theme.spacing(1),
    },
}));
//# sourceMappingURL=ComplexStaticDateRangePicker.styles.js.map